// Video / 360 Video interactions
export const EXP_VIDEO_START = 'EXP_Video_Start'
export const EXP_VIDEO_PAN = 'EXP_Video_Pan'
export const EXP_VIDEO_QUALITYCHANGE = 'EXP_Video_QualityChange'
export const EXP_VIDEO_MUTE = 'EXP_Video_Mute'
export const EXP_VIDEO_UNMUTE = 'EXP_Video_Unmute'
export const EXP_INTROVIDEO_SKIPPED = 'EXP_IntroVideo_Skipped'
export const EXP_VIDEO_SEEK = 'EXP_Video_Seek'

// Pano interactions
export const EXP_PANO_PAN = 'EXP_Pano_Pan'
export const EXP_PANO_TAP = 'EXP_Pano_Tap'

// Positional Media interactions
export const EXP_POSMEDIA_STARTED = 'EXP_PosMedia_Started'

// Stops
export const EXP_STOPLIST_SELECTION = 'EXP_StopList_Selection'
export const EXP_STOPLIST_HOVER = 'EXP_Stoplist_hover'
export const EXP_STOPLIST_SCROLL = 'EXP_Stoplist_scroll'
export const EXP_SCENE_ENTER = 'EXP_Scene_Enter'
export const EXP_SCENE_10SECONDS = 'EXP_Scene_10seconds'

// Trigger
export const EXP_TRIGGER_POPUP_HOVER = 'EXP_Trigger_Popup_Hover'
export const EXP_TRIGGER_POPUP_ENTER_TAPPED = 'EXP_Trigger_Popup_Enter_tapped'
export const EXP_TRIGGER_VIDEO_STARTED = 'EXP_Trigger_Video_Started'
export const EXP_TRIGGER_VIDEO_PAN = 'EXP_Trigger_Video_Pan'

// Hotspots
export const EXP_HOTSPOT_TAPPED = 'EXP_Hotspot_tapped'
export const EXP_HOTSPOT_HOVER = 'EXP_Hotspot_Hover'
export const EXP_HOTSPOT_TEXT_COMPLETED = 'EXP_Hotspot_Text_Completed'
export const EXP_HOTSPOT_VIDEODESCRIPTION_COMPLETED = 'EXP_Hotspot_VideoDescription_Completed'
export const EXP_HOTSPOT_IMAGEDESCRIPTION_COMPLETED = 'EXP_Hotspot_ImageDescription_Completed'
export const EXP_HOTSPOT_VIDEO_VIEWED = 'EXP_Hotspot_Video_Viewed'
export const EXP_HOTSPOT_PANO_VIEWED = 'EXP_Hotspot_Pano_Viewed'
export const EXP_HOTSPOT_IMAGE_VIEWED = 'EXP_Hotspot_Image_Viewed'

// Walking
export const EXP_SCENE_NEXTARROW_TAPPED = 'EXP_Scene_NextArrow_tapped'
export const EXP_SCENE_BACKARROW_TAPPED = 'EXP_Scene_BackArrow_tapped'

// Guide/Info
export const EXP_TOURGUIDE_ON = 'EXP_TourGuide_On'
export const EXP_TOURGUIDE_OFF = 'EXP_TourGuide_Off'
export const EXP_TOURGUIDE_CHANGELANGUAGE = 'EXP_TourGuide_ChangeLanguage'
export const EXP_TOURGUIDE_INFO_COMPLETED = 'EXP_TourGuide_Info_Completed'

// Supplemental Media
export const EXP_SUPPMEDIA_HOVER = 'EXP_SuppMedia_Hover'
export const EXP_SUPPMEDIA_TAPPED = 'EXP_SuppMedia_tapped'
export const EXP_SUPPMEDIA_SHARED = 'EXP_SuppMedia_Shared'
export const EXP_SUPPMEDIA_VIDEO_VIEWED = 'EXP_SuppMedia_Video_Viewed'
export const EXP_SUPPMEDIA_VIDEO_INFO_TAPPED = 'EXP_SuppMedia_Video_Info_Tapped'
export const EXP_SUPPMEDIA_VIDEO_EXPAND = 'EXP_SuppMedia_Video_Expand'
export const EXP_SUPPMEDIA_PHOTO_INFO_TAPPED = 'EXP_SuppMedia_Photo_Info_Tapped'
export const EXP_SUPPMEDIA_PANO_INFO_TAPPED = 'EXP_SuppMedia_Pano_Info_Tapped'
export const EXP_SUPPMEDIA_PANO_VIEWED = 'EXP_SuppMedia_Pano_Viewed'

// Map
export const EXP_MAP_COLLAPSED = 'EXP_Map_Collapsed'
export const EXP_MAP_HOVER = 'EXP_Map_Hover'
export const EXP_MAP_ZOOM_IN = 'EXP_Map_Zoom_In'
export const EXP_MAP_ZOOM_OUT = 'EXP_Map_Zoom_Out'
export const EXP_MAP_STOP_TAPPED = 'EXP_Map_Stop_tapped'

// VR
export const EXP_VRBUTTON_TAPPED = 'EXP_VRButton_tapped'

// Share
export const EXP_MENU_SHARE_TAPPED = 'EXP_Menu_Share_Tapped'

// General
export const EXP_LOCATIONSDROPDOWN_TAPPED = 'EXP_LocationsDropdown_Tapped'
export const EXP_LOCATIONSDROPDOWN_LOCATIONTAPPED = 'EXP_LocationsDropdown_LocationTapped'
export const EXP_CTABUTTON_TAPPED = 'EXP_CTAButton_tapped'
export const EXP_EXPERIENCE_EXPAND = 'EXP_Experience_Expand'
export const EXP_EXPERIENCE_MINIMIZED = 'EXP_Experience_Minimized'

// Registration
export const EXP_REGISTRATIONSUBMITTED = 'EXP_RegistrationSubmitted'
